import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import NearMeIcon from '@mui/icons-material/NearMe';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { PortCodeFetch } from '../../features/port-code.feature';
import { useAppDispatch, useAppSelector } from '../../hooks';

interface PscAisDestinationProps {
    imoNumber: string;
}

const PscAisDestination = ({ imoNumber }: PscAisDestinationProps) => {
    const dispatch = useAppDispatch();

    const aisData = useAppSelector((state) => state.Ais.List[imoNumber]);
    const portCodeData = useAppSelector((state) => state.PortCode.List[imoNumber]);

    useEffect(() => {
        if (aisData?.AIS?.Destination && !portCodeData) {
            dispatch(PortCodeFetch.GetBySearch({ imoNumber, searchString: aisData.AIS.Destination }));
        }
    }, [imoNumber, aisData]);

    const isLoading = aisData?.IsLoading;

    return (
        <>
            {aisData && !aisData.AIS && !aisData.IsLoading ? (
                // AIS Data NOT Available
                <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                    <ErrorOutlineOutlined sx={{ height: '18px' }} />
                    <Stack direction={'column'} spacing={0.5} alignItems={'flex-start'}>
                        Not Found
                        <Typography variant="caption" display="block">
                            Note: Unable to Get AIS Data
                        </Typography>
                    </Stack>
                </Stack>
            ) : isLoading ? (
                <CircularProgress size={18} />
            ) : (
                <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                    <NearMeIcon sx={{ height: '18px' }} />
                    <Stack direction={'column'} spacing={0.5} alignItems={'flex-start'}>
                        {aisData?.AIS?.Destination}
                        <Typography variant="caption" display="block">
                            {portCodeData && `${portCodeData.PortCode?.PortName}, ${portCodeData.PortCode?.Country}`} <br />
                            {portCodeData && portCodeData.PortCode?.MOU && `${portCodeData.PortCode?.MOU?.join(', ')}`}
                            {portCodeData && (!portCodeData.PortCode?.MOU || portCodeData.PortCode?.MOU.length === 0) && `MOU Unsupported`}
                        </Typography>
                    </Stack>
                </Stack>
            )}
        </>
    );
};

export default PscAisDestination;
